(function () {
    'use strict';

    angular
        .module('app.help')
        .controller('HelpController', HelpController);

    HelpController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function HelpController(common, dataservice) {
        var vm = this;
        vm.title = 'Help';
        vm.displayedItems = [];
        vm.items = [];
        
        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function getItems() {
            if (common.userService.isAuthenticated()) {
                return dataservice.getItems('api/HelpText/Faqs').then(function (response) {
                    vm.items = response.data;
                    vm.displayedItems = [].concat(vm.items);
                    return vm.items;
                }, function (error) { });
            }
            
        }
        
    }
})();
